<template>
  <div :id="`encode-analyse-${x}-country-company`" class="encode-analyse-x-country-company" v-loading="loading" v-show="!hidden">
    <div class="title" ref="title">
      <div class="text">
        <div style="font-weight: bold">
          【<span style="color: var(--themeColor, #3152AF)">{{ $store.getters.titleText }}</span>{{ kanji }}位HS编码国家{{ companyType === "importer" ? "供应商" : "采购商" }}分析】
        </div>
        <span class="sub-title">(该报表不包含船运数据)</span>
      </div>
      <div style="display: flex; align-items: center">
        <el-radio-group v-model="controlForm.option" size="mini">
          <el-radio-button :label="0">频次</el-radio-button>
          <el-radio-button :label="1">金额</el-radio-button>
          <el-radio-button :label="2">数量</el-radio-button>
          <el-radio-button :label="3">重量</el-radio-button>
        </el-radio-group>
        <img v-show="false" class="icon" src="@/firm/images/company/icon-download.png" style="margin-left: 1em" />
      </div>
    </div>
    <div class="content">
      <div class="first">
        <p class="title">【编码】</p>
        <div class="container">
          <div @click="handleFirstItemClick(index, item.encode)" class="item" :class="{ selected: dataFirstSelectedIndex === index }" v-for="(item, index) of dataFirst" :key="index">
            <div class="main">
              <el-tooltip placement="bottom-start" :content="item.description">
                <div style="width: 60px; font-size: 14px" class="signle-line-omit">{{ item.encode }}</div>
              </el-tooltip>
              <el-progress class="custome-el-progress-bg" style="width: 135px" :color="$store.getters.barColor" :stroke-width="10" :percentage="item.percentage" :show-text="false" />
              <div style="margin-left: 10px; font-size: 14px">{{ item.percentage.toFixed(1) }}%</div>
            </div>
            <div class="description" v-show="dataFirstSelectedIndex === index">
              <img src="@/firm/images/company/icon-tag-b.png" style="margin-left: 1em; height: 15px" />
              <div style="display: flex; margin-top: 1em; margin-left: 5px; justify-content: space-between">
                <span>{{ ["频次", "金额", "数量", "重量"][controlForm.option] }}:{{ item[["frequency", "amount", "count", "weight"][controlForm.option]] }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="second">
        <p class="title">【国家】</p>
        <div class="container">
          <div class="item" @click="handleSecondItemClick(index, item.countryCode)" :class="{ selected: dataSecondSelectedIndex === index }" v-for="(item, index) of dataSecond" :key="index">
            <div class="main">
              <img class="flag" style="margin-left: 12px" :src="item.flagSrc" />
              <el-tooltip effect="light" :content="item.country" placement="top-start">
                <div class="country signle-line-omit" style="width: 40px; margin-right: 5px; font-size: 14px">{{ item.country }}</div>
              </el-tooltip>
              <el-progress class="custome-el-progress-bg" style="width: 120px" color="#746B63" :stroke-width="10" :percentage="item.percentage" :show-text="false" />
              <div style="margin-left: 12px; font-size: 14px">{{ item.percentage.toFixed(1) }}%</div>
            </div>
            <div class="description" v-show="dataSecondSelectedIndex === index">
              <img src="@/firm/images/company/encode/line-company.png" style="margin-left: 4.2em; height: 15px" />
              <div style="display: flex; width: 70%; margin-top: 1em; margin-left: 5px; justify-content: space-between">
                <span>{{ ["频次", "金额", "数量", "重量"][controlForm.option] }}:{{ item[["frequency", "amount", "count", "weight"][controlForm.option]] }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="third">
        <p class="title">【{{ companyType === "importer" ? "供应商" : "采购商" }}】</p>
        <div class="container">
          <div class="item" v-for="(item, index) of dataThird" :key="index">
            <div class="top">{{ item.company }}</div>
            <div class="main">
              <span :style="{ background: companyType === 'importer' ? '#E5694F' : '#B88D6A' }" style="color: #fff; padding: 0 0.5em; margin: 0 1em">{{ `TOP${index + 1}` }}</span>
              <el-progress style="width: 360px" :color="companyType === 'importer' ? '#E5694F' : '#B88D6A'" :stroke-width="10" :percentage="item.percentage" :show-text="false" />
              <div style="margin-left: 12px">{{ item[["frequency", "amount", "count", "weight"][controlForm.option]] }}({{ item.percentage.toFixed(1) }}%)</div>
            </div>
            <div class="description">
              <img :src="companyType === 'importer' ? img.caigou : img.gongying" style="margin-left: 6em; height: 15px" />
              <div style="display: flex; width: 75%; margin-top: 1em; margin-left: 5px; justify-content: space-between">
                <span>频次:{{ item.frequency }}</span>
                <span>金额:{{ item.amount }}</span>
                <span>重量:{{ item.weight }}</span>
                <span>数量:{{ item.count }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "@/firm/plugins/axios";
import { mapState, mapGetters, mapMutations } from "vuex";
import LazyOperation from "@/firm/plugins/lazy-execute";
import { AnchorInditor } from "../../utils";

const lazyOperation = {
  "6": null,
  "4": null,
  "2": null,
};

export default Vue.extend({
  inheritAttrs: false,
  props: ["x", "kanji", "anchor", "firstHTTP", "secondHTTP", "thirdHTTP"],
  data() {
    return {
      img: {
        caigou: require("@/firm/images/company/encode/line-caigou.png"),
        gongying: require("@/firm/images/company/encode/line-gongying.png"),
      },
      hidden: false,
      loading: false,
      controlForm: {
        option: 0,
      },
      dataFirst: [],
      dataFirstSelectedIndex: 0,
      dataSecond: [],
      dataSecondSelectedIndex: 0,
      dataThird: [],
    };
  },
  computed: {
    ...mapState(["company", "companyType"]),
    ...mapState("controlFormGlobal", {
      ie: "ie",
      dataCountry: "dataCountry",
      dateRange: "dateRange",
      hsCode: "hsCode",
      importer: "importer",
      exporter: "exporter",
      country: "country",

      exHsCode: "exHsCode",
      exExporter: "exExporter",
      exImporter: "exImporter",
      exCountry: "exCountry",
    }),
    ...mapGetters("controlFormGlobal", {
      startTime: "startTime",
      endTime: "endTime",
    }),
  },
  watch: {
    "controlForm.option"() {
      lazyOperation[this.x]?.reobserve();
    },
    ie() {
      this.hidden = false;
      this.setAnchorFlag([[this.anchor, true]]);
      lazyOperation[this.x]?.reobserve();
    },
    dataCountry() {
      this.hidden = false;
      this.setAnchorFlag([[this.anchor, true]]);
      lazyOperation[this.x]?.reobserve();
    },
    dateRange() {
      this.hidden = false;
      this.setAnchorFlag([[this.anchor, true]]);
      lazyOperation[this.x]?.reobserve();
    },
    hsCode() {
      this.hidden = false;
      this.setAnchorFlag([[this.anchor, true]]);
      lazyOperation[this.x]?.reobserve();
    },
    importer() {
      this.hidden = false;
      this.setAnchorFlag([[this.anchor, true]]);
      lazyOperation[this.x]?.reobserve();
    },
    exporter() {
      this.hidden = false;
      this.setAnchorFlag([[this.anchor, true]]);
      lazyOperation[this.x]?.reobserve();
    },
    country() {
      this.hidden = false;
      this.setAnchorFlag([[this.anchor, true]]);
      lazyOperation[this.x]?.reobserve();
    },

    exHsCode() {
      this.hidden = false;
      this.setAnchorFlag([[this.anchor, true]]);
      lazyOperation[this.x]?.reobserve();
    },
    exExporter() {
      this.hidden = false;
      this.setAnchorFlag([[this.anchor, true]]);
      lazyOperation[this.x]?.reobserve();
    },
    exImporter() {
      this.hidden = false;
      this.setAnchorFlag([[this.anchor, true]]);
      lazyOperation[this.x]?.reobserve();
    },
    exCountry() {
      this.hidden = false;
      this.setAnchorFlag([[this.anchor, true]]);
      lazyOperation[this.x]?.reobserve();
    },

    companyType() {
      this.hidden = false;
      this.setAnchorFlag([[this.anchor, true]]);
      lazyOperation[this.x]?.reobserve();
    },
  },
  methods: {
    ...mapMutations("anchor", {
      setAnchorFlag: "setAnchorFlag",
      setCurrent: "setCurrent",
    }),
    async getDataFirst() {
      try {
        const res = await axios({
          method: "post",
          url: this.firstHTTP,
          data: {
            pageIndex: 1,
            pageSize: 100,
            ie: this.ie,
            importer: this.importer,
            exporter: this.exporter,
            dataCountry: this.dataCountry,
            country: this.country,
            startTime: this.startTime,
            endTime: this.endTime,
            hsCode: this.hsCode,
            sortType: this.controlForm.option,
            noHsCode: this.exHsCode,
            noImporter: this.exImporter,
            noExporter: this.exExporter,
            noCountry: this.exCountry,
            company: this.company,
            companyType: this.companyType,
          },
        });
        const data = res.data.result.data.map((item) => ({
          encode: item.encode, //编码
          description: item.name, //编码信息
          percentage: item[["frequencyRatio", "amountRadio", "countRadio", "weightRadio"][this.controlForm.option]], //百分比
          frequency: item.frequency, //频次
          amount: item.amount, //金额
          count: item.count, //数量
          weight: item.weight, //重量
        }));
        if (data.length === 0) {
          throw new Error("");
        }
        return Promise.resolve(data);
      } catch (error) {
        return Promise.reject("encode-analyse-x-country-company getDataFirst reject");
      }
    },
    async handleFirstItemClick(index, encode) {
      try {
        this.loading = true;
        const dataSecond = await this.getDateSecond(encode);
        this.dataSecond = dataSecond;
        this.dataFirstSelectedIndex = index;
        const dataThird = await this.getDataThird((this.dataFirst[index]).encode, dataSecond[0].countryCode);
        this.dataThird = dataThird;
        this.dataSecondSelectedIndex = 0;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async getDateSecond(encode) {
      try {
        const res = await axios({
          method: "post",
          url: this.secondHTTP,
          data: {
            pageIndex: 1,
            pageSize: 100,
            ie: this.ie,
            importer: this.importer,
            exporter: this.exporter,
            dataCountry: this.dataCountry,
            country: this.country,
            startTime: this.startTime,
            endTime: this.endTime,
            hsCode: [encode],
            sortType: this.controlForm.option,
            noHsCode: this.exHsCode,
            noExporter: this.exExporter,
            noImporter: this.exImporter,
            noCountry: this.exCountry,
            company: this.company,
            companyType: this.companyType,
          },
        });
        const data = res.data.result.data.map((item) => ({
          flagSrc: item.flagSrc,
          country: item.countryCN,
          percentage: item[["frequencyRatio", "amountRadio", "countRadio", "weightRadio"][this.controlForm.option]],
          frequency: item.frequency,
          amount: item.amount,
          count: item.count,
          weight: item.weight,
          countryCode: item.country,
        }));
        return Promise.resolve(data);
      } catch (error) {
        return Promise.reject("encode-analyse-x-country-company getDateSecond reject");
      }
    },
    async handleSecondItemClick(index, countryCode) {
      try {
        this.loading = true;
        const dataThird = await this.getDataThird((this.dataFirst[this.dataFirstSelectedIndex]).encode, countryCode);
        this.dataThird = dataThird;
        this.dataSecondSelectedIndex = index;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async getDataThird(encode, country) {
      try {
        const res = await axios({
          method: "post",
          url: this.companyType === "importer" ? "/search/Credit/Ranking/Exporter" : "/search/Credit/Ranking/Importer", //this.thirdHTTP,
          data: {
            pageIndex: 1,
            pageSize: 100,
            ie: this.ie,
            importer: this.importer,
            exporter: this.exporter,
            dataCountry: this.dataCountry,
            country: [country],
            startTime: this.startTime,
            endTime: this.endTime,
            hsCode: [encode],
            sortType: this.controlForm.option,
            noHsCode: this.exHsCode,
            noExporter: this.exExporter,
            noImporter: this.exImporter,
            noCountry: this.exCountry,
            company: this.company,
            companyType: this.companyType,
          },
        });
        const data = res.data.result.data.map((item) => ({
          company: item.company,
          percentage: item[["frequencyRatio", "amountRadio", "countRadio", "weightRadio"][this.controlForm.option]],
          frequency: item.frequency,
          amount: item.amount,
          count: item.count,
          weight: item.weight,
        }));
        return Promise.resolve(data);
      } catch (error) {
        return Promise.reject("encode-analyse-x-country-company getDateSecond reject");
      }
    },
  },
  mounted() {
    lazyOperation[this.x] = new LazyOperation(async () => {
      try {
        this.loading = true;
        const dataFirst = await this.getDataFirst();
        this.dataFirst = dataFirst;
        this.dataFirstSelectedIndex = 0;
        const dataSecond = await this.getDateSecond(dataFirst[0].encode);
        this.dataSecond = dataSecond;
        this.dataSecondSelectedIndex = 0;
        const dataThird = await this.getDataThird(dataFirst[0].encode, dataSecond[0].countryCode);
        this.dataThird = dataThird;
      } catch {
        this.hidden = true;
        this.setAnchorFlag([[this.anchor, false]]);
      } finally {
        this.loading = false;
      }
    }, this.$el);
    new AnchorInditor(() => {
      this.setCurrent(this.anchor);
    }, this.$refs["title"]);
  },
});
</script>

<style lang="scss" scoped>
@import "@/firm/scss/mixin.scss";

.encode-analyse-x-country-company {
  margin-top: 1em;
  background: #fff;
  padding: 1rem;
  padding-top: 0;
  @include mixin-panel-title;

  .content {
    $contentHeight: 400px;
    $highlighBackground: #f5e8da;
    $borderRadius: 10px;
    display: flex;
    height: $contentHeight;
    $titleHeight: 3em;
    $selecedHeight: 4em;

    .first {
      background: #eeeeee;
      border-top-left-radius: $borderRadius;
      border-bottom-left-radius: $borderRadius;
      width: 25%;
      height: $contentHeight;

      .title {
        height: $titleHeight;
        line-height: $titleHeight;
      }

      .container {
        height: calc(100% - #{$titleHeight});
        overflow-y: auto;

        &::-webkit-scrollbar {
          width: 6px;
        }

        &::-webkit-scrollbar-thumb {
          background: #d5d5d5;
        }

        scrollbar-width: thin;
        scrollbar-color: #d5d5d5 #fff;

        .item {
          cursor: pointer;
          margin-bottom: 1em;

          &.selected {
            background: $highlighBackground;
            height: $selecedHeight;
          }

          .main {
            margin: 0;
            margin-left: 1em;
            display: flex;
            align-items: center;
            height: 28px;
          }

          .description {
            display: flex;
            align-items: center;
            padding-left: 2em;
            font-size: 0.8em;
          }
        }
      }
    }

    .second {
      width: 25%;
      height: $contentHeight;
      background: #f5e8da;

      .title {
        height: $titleHeight;
        line-height: $titleHeight;
      }

      .container {
        height: calc(100% - #{$titleHeight});
        overflow-y: auto;

        &::-webkit-scrollbar {
          width: 6px;
        }

        &::-webkit-scrollbar-thumb {
          background: #d5d5d5;
        }

        scrollbar-width: thin;
        scrollbar-color: #d5d5d5 #fff;

        .item {
          cursor: pointer;
          margin-bottom: 1em;

          &.selected {
            background: #e8c6a1;
            height: $selecedHeight;
          }

          .main {
            display: flex;
            align-items: center;
            height: 28px;

            .flag {
              height: 1em;
              margin-right: 8px;
              box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.16);
            }
          }

          .description {
            display: flex;
            align-items: center;
            font-size: 0.8em;
          }
        }
      }
    }

    .third {
      width: 50%;
      height: $contentHeight;
      background: #e8c6a1;
      border-top-right-radius: $borderRadius;
      border-bottom-right-radius: $borderRadius;

      .title {
        height: $titleHeight;
        line-height: $titleHeight;
      }

      .container {
        height: calc(100% - #{$titleHeight});
        overflow-y: auto;

        &::-webkit-scrollbar {
          width: 6px;
        }

        &::-webkit-scrollbar-thumb {
          background: #d5d5d5;
        }

        scrollbar-width: thin;
        scrollbar-color: #d5d5d5 #fff;

        .item {
          margin-bottom: 1em;

          .top {
            padding-left: 70px;
            font-size: 12px;
          }

          .main {
            font-size: 12px;
            display: flex;
            align-items: center;
          }

          .description {
            display: flex;
            align-items: center;
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style>
